module.exports = __webpack_public_path__ + "static/media/solar-field.8c748626.svg";